import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import InspiratoPage from 'pages/PartnerPages/InspiratoPage';

const InspiratoPages = () => (
  <Router>
    <Switch>
      <Route
        exact path="/inspirato-rewards"
        render={(props) => (
          <InspiratoPage
            {...props}
            quickQuoteTitle="Prima, Mezza, and Avanti Members get 50% off a round-trip shipment"
            couponCode="ISPO24"
            termsConditionsText="Loyalty members of all three Inspirato tiers, Prima, Mezza, and Avanti, will receive the first leg of a round trip shipment for free once per calendar year."
          />
        )}
      />
      <Route
        exact path="/inspirato"
        render={(props) => (
          <InspiratoPage
            {...props}
            quickQuoteTitle="All Inspirato Members get 20% off their shipments"
            termsConditionsText="All Inspirato Members will receive 20% off all Ship&Play services year-round."
          />
        )}
      />
    </Switch>
  </Router>
);

document.addEventListener('DOMContentLoaded', () => {
  ReactDOM.render(<InspiratoPages />, document.body.appendChild(document.createElement('div')))
});
